module.exports = __webpack_public_path__ + "img/airbnb.36aa5cff.png";